module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/quick-access/quick-access.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/quick-access/quick-access.component.css
// module chunks = main